import { useEffect } from 'react';

interface JsonLdProps {
  data: object;
}

export default function JsonLd({ data }: JsonLdProps) {
  const serialized = JSON.stringify(data);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = serialized;
    script.setAttribute('data-seo-jsonld', 'true');
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, [serialized]);

  return null;
}